import { useEffect, useState } from "react";

export interface IUploadProps {
  id: number;
  hint?: string;
  setFileParent: (f: File) => void;
  acceptedTypes: string;
  oldUrl: string;
  isDirect: boolean;
  uploadText: string;
  buttonText: string;
  name: string;
  // type?: string;
}

const Upload = (props: IUploadProps): JSX.Element => {
  const [file, setFile] = useState<File | null>();
  const [imgUrl, setImgUrl] = useState<string>(props.oldUrl);
  const [uploadText, setUploadText] = useState<string>(props.uploadText);

  // Update upload preview from remote source on element load
  useEffect(() => {
    if (imgUrl !== "") {
      const urlParts = imgUrl.split("/");
      if (isVideo(imgUrl)) {
        getStillVideoFrameFromUrl(imgUrl).then((imageDataUrl) => {
          setUploadText(urlParts[urlParts.length - 1]);
          setImgUrl(imageDataUrl);
        });
      } else {
        const urlParts = imgUrl.split("/");
        setUploadText(urlParts[urlParts.length - 1]);
        setImgUrl(imgUrl);
      }
    }
  }, []);

  // Update upload preview from local source on `file` change
  useEffect(() => {
    if (file) {
      props.setFileParent(file);

      // Set image preview from local source
      if (isVideo(file.name)) {
        const url = URL.createObjectURL(file);
        getStillVideoFrameFromUrl(url).then((imageDataUrl) => {
          setUploadText(file.name);
          setImgUrl(imageDataUrl);
        });
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setUploadText(file.name);
          if (reader.result) {
            setImgUrl(reader.result.toString());
          }
        };
      }
    }
  }, [file]);

  // TODO: The following are styles copied from the SCSS, find a better way to define them
  // TODO: Richard will convert these to tailwind
  const inputStyle = { height: "inherit" };
  const imageStyle = {
    height: "inherit",
    aspectRatio: 1,
    backgroundColor: "white",
    padding: "2px",
    border: "1px solid black",
  };
  const labelStyle = {
    height: "inherit",
    padding: "10px",
    marginRight: "auto",
    fontFamily: "Manrope",
    color: "white",
    fontWeight: "bold",
    fontSize: "16px",
  };
  const uploadTitle = {
    color: "#333333",
  };
  const inputContainer = {
    backgroundColor: "#a0a0a0",
    height: "45px",
    display: "flex",
    FlexDirection: "row",
  };
  const uploadButton = {
    TextAlign: "center",
    width: "10%",
    padding: "10px",
    borderRadius: "2px",
    backgroundColor: "#a1866e",
    color: "white",
  };
  const sub = {
    fontSize: "12px",
    color: "#333333",
    fontWeight: 100,
    margin: "4px",
  };

  return (
    <>
      <label style={uploadTitle} htmlFor={"upload_file_" + props.id}>
        {props.name}
      </label>
      {props.hint && <div>{props.hint}</div>}
      <div style={inputContainer}>
        <input
          type="file"
          onChange={(e) => setFile(e.target.files ? e.target.files[0] : null)}
          style={inputStyle}
          accept={props.acceptedTypes}
          id={"upload_file_" + props.id}
          data-has-url={props.oldUrl !== ""}
          data-file-url={props.oldUrl}
          data-is-direct={props.isDirect}
          hidden={true}
        ></input>
        <img
          style={imageStyle}
          src={imgUrl || "/assets/default-image.jpg"}
        ></img>
        <label style={labelStyle}>{uploadText}</label>
        <label style={uploadButton} htmlFor={"upload_file_" + props.id}>
          {props.buttonText}
        </label>
      </div>
    </>
  );
};

const isVideo = (fileName: string) => {
  // TODO: Load `supportedVideoTypes` from backend?
  const supportedVideoTypes = [".mp4"];
  const fileNameParts = fileName.split(".");
  return supportedVideoTypes.includes(
    `.${fileNameParts[fileNameParts.length - 1]}`
  );
};

const getStillVideoFrameFromUrl = (url: string) => {
  return new Promise<string>((resolve, reject) => {
    // Source (modified from here): https://stackoverflow.com/a/36046775
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.src = url;
    video.volume = 0;
    video
      .play()
      .then(() => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.pause();
        video.remove();
        resolve(canvas.toDataURL("image/jpg"));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { Upload, isVideo };
